import styled from 'styled-components/macro';

const InfoWrapper = styled.span`
  color: #fff;
  opacity: 0.4;
  transition: opacity 0.15s ease-out;

  &:hover {
    opacity: 1;
  }

  ${({ isSmall }) => isSmall && `
    & svg {
      width: 14px;
      height: 14px;
    }
  `}
`;

export default InfoWrapper;
